import { track } from '@tldraw/tldraw'
import { Button } from 'blaze-ui/Button'
import { ArrowRightSquareContained } from 'blaze-ui/icons/20/ArrowRightSquareContained'
import { Menu } from 'components/Menu/Menu'
import { SelectableItem } from 'components/Menu/MenuItem'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Color, GradientColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { observer } from 'mobx-react-lite'
import Styles from './ColorsPanel.module.scss'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  selectedColor: GradientColor
  onNewColorChange: (color: Color) => void
}

const anglesToDirections: { [key: number]: string } = {
  [-45]: 'Up Diagonal',
  0: 'Horizontal',
  45: 'Down Diagonal',
  90: 'Vertical',
}

export const directionsToAngles: { [key: string]: number } = {
  'Up Diagonal': -45,
  Horizontal: 0,
  'Down Diagonal': 45,
  Vertical: 90,
}

export const GradientDirectionEditor = track(
  observer(({ selectedColor, onNewColorChange }: Props) => (
    <div className={Styles.gradientDirectionCardContainer}>
      <div className={Styles.headerWithIcon}>
        <ArrowRightSquareContained color="#0FABB6" />
        <Text variant="smallList">Direction</Text>
      </div>
      <MenuTrigger>
        <Button size="md" variant="tertiary" withChevron="down">
          {anglesToDirections[selectedColor.angle]}
        </Button>
        <Menu
          selectionMode="single"
          selectedKeys={[anglesToDirections[selectedColor.angle]]}
          onAction={(key) => {
            const newAngle = directionsToAngles[key]

            if (
              newAngle === selectedColor.angle ||
              newAngle === selectedColor.angle + 180 ||
              newAngle === selectedColor.angle - 180
            ) {
              return
            }

            const newColor = {
              ...selectedColor,
              angle: newAngle,
            }
            onNewColorChange(newColor)
          }}
        >
          <SelectableItem type="item" key={anglesToDirections[0]}>
            {anglesToDirections[0]}
          </SelectableItem>
          <SelectableItem type="item" key={anglesToDirections[90]}>
            {anglesToDirections[90]}
          </SelectableItem>
          <SelectableItem type="item" key={anglesToDirections[-45]}>
            {anglesToDirections[-45]}
          </SelectableItem>
          <SelectableItem type="item" key={anglesToDirections[45]}>
            {anglesToDirections[45]}
          </SelectableItem>
        </Menu>
      </MenuTrigger>
    </div>
  )),
)
